import { createHook, createSelector, type BoundActions } from 'react-sweet-state';

import type { State, ImporterSourceItem } from '../../../../common/types';
import type { Actions } from '../../actions';
import { Store } from '../../main';

export type UseSourceItems = () => [
	ImporterSourceItem[] | null,
	Partial<BoundActions<State, Actions>>,
];

export const sourceItemsSelector = createSelector(
	(state: State): ImporterSourceItem[] | null => state.sourceItems,
	(newState: ImporterSourceItem[] | null) => newState,
);

export const useSourceItems = createHook(Store, {
	selector: sourceItemsSelector,
});

export type UseSelectedSourceItem = () => [
	ImporterSourceItem | undefined,
	Partial<BoundActions<State, Actions>>,
];

export const selectedSourceItemSelector = createSelector(
	(state: State): ImporterSourceItem | undefined =>
		state.sourceItems?.find((item) => item.key === state.importType),
	(newState: ImporterSourceItem | undefined) => newState,
);

export const useSelectedSourceItem = createHook(Store, {
	selector: selectedSourceItemSelector,
});
